import { Container, Row, Col } from "react-bootstrap";
import React from "react";

export const Skills = () => {
    const skillCategories = [
        {
            title: "Programming Languages",
            skills: ["Python", "Java", "C++", "C", "Rust", "JavaScript", "TypeScript", "HTML", "CSS", "SQL", "GraphQL", "Bash/Shell"]
        },
        {
            title: "Frameworks / Libraries",
            skills: ["Node.js", "Express", "React", "Spring", "TensorFlow", "PyTorch", "scikit-learn", "SciPy", "NumPy", "Pandas", "MCP", "gRPC", "Agent Development Kits (ADK)"]
        },
        {
            title: "Tools & Technology",
            skills: ["Git", "PostgreSQL", "Docker", "Kubernetes", "Helm", "GitHub Actions", "AWS", "Azure", "CUDA", "Secure Sandboxing/Containerization", "Cryptographic Token Delegation", "Headless CLI", "Jira", "Agile Scrum"]
        },
        {
            title: "Operating Systems",
            skills: ["Linux", "Windows", "macOS"]
        }
    ];

    return (
        <section className="skills-section" id="skills">
            <Container>
                <h2 className="section-title text-center">Skills</h2>
                <Row className="mt-5">
                    {skillCategories.map((category, index) => (
                        <Col md={6} lg={3} key={index} className="mb-4">
                            <div className="skill-category-card">
                                <h4>{category.title}</h4>
                                <div className="tech-tags mt-3">
                                    {category.skills.map((skill, i) => (
                                        <span className="tech-tag" key={i}>{skill}</span>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}
